import { css, Sizes } from 'styled-components';

export type MarginProps = {
  mx?: Sizes;
  my?: Sizes;
  mb?: Sizes;
  mt?: Sizes;
  ml?: Sizes | 'auto';
  mr?: Sizes | 'auto';
};

export const styledMargin = css<MarginProps>`
  ${(props) =>
    props.mx &&
    css`
      margin-left: ${props.theme.sizes[props.mx]};
      margin-right: ${props.theme.sizes[props.mx]};
    `}
  ${(props) =>
    props.my &&
    css`
      margin-top: ${props.theme.sizes[props.my]};
      margin-bottom: ${props.theme.sizes[props.my]};
    `}
  ${(props) =>
    props.mt &&
    css`
      margin-top: ${props.theme.sizes[props.mt]};
    `}
  ${(props) =>
    props.mr &&
    css`
      margin-right: ${props.theme.sizes[props.mr]};
    `}
  ${(props) =>
    props.mb &&
    css`
      margin-bottom: ${props.theme.sizes[props.mb]};
    `}
  ${(props) =>
    props.ml &&
    css`
      margin-left: ${props.theme.sizes[props.ml]};
    `}
`;
